import {OrganisationsModel} from '../../../library/src/organisations/models/OrganisationsModel';
export const GET_ORGANISATIONS = 'GET_ORGANISATIONS';
export interface GetOrganisationsAction {
  type: typeof GET_ORGANISATIONS;
}

export const GET_ORGANISATIONS_SUCCESS = 'GET_ORGANISATIONS_SUCCESS';
export interface GetOrganisationsSuccessAction {
  type: typeof GET_ORGANISATIONS_SUCCESS;
  payload: OrganisationsModel[];
}

export type SharedOrganisationsActionsType =
  | GetOrganisationsAction
  | GetOrganisationsSuccessAction;

export const sharedOrganisationActions = {
  getAllowedOrganisations: (): GetOrganisationsAction => ({
    type: GET_ORGANISATIONS,
  }),

  getAllowedOrganisationsSuccess: (
    data: OrganisationsModel[],
  ): GetOrganisationsSuccessAction => ({
    type: GET_ORGANISATIONS_SUCCESS,
    payload: data,
  }),
};
